// Typed access to the LOCKED FAQ-cluster data. The JSON is generated from
// the Ticket 5 package fragments by scripts/build-faq-cluster-data.js and is
// the single source of truth shared with scripts/prerender.js (which reads
// the same .json for SEO + JSON-LD injection). Do not hand-edit the JSON —
// re-run the generator after any package update.
import rawData from './faqClusterData.json';

export interface FaqClusterEntry {
  /** Source fragment filename, for traceability. */
  file: string;
  locale: 'en' | 'fr';
  htmlLang: string;
  ogLocale: string;
  /** Opposite-locale sibling route (for hreflang). */
  sibling: string;
  title: string;
  description: string;
  /** Locked <article> HTML, CTA href already wired to /configure. */
  article: string;
  /** Locked FAQPage + Article JSON-LD, serialized. */
  jsonLd: string;
}

const data = rawData as Record<string, FaqClusterEntry>;

/** All 6 FAQ-cluster route paths (EN + FR). */
export const FAQ_CLUSTER_ROUTES = Object.keys(data);

// Netlify serves these pages at the trailing-slash URL (/faq/x → 301 → /faq/x/),
// while the data is keyed without it, so the lookup ignores trailing slashes.
export function getFaqCluster(pathname: string): FaqClusterEntry | undefined {
  return data[pathname.replace(/\/+$/, '')];
}

export default data;
